import { SVGProps } from 'react';

export const ResendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.94 13.808v.034l.001-.034zM2.248 7.983h-.035.035zM8.072 2.29v-.034.034z"
      fill="currentColor"
    />
    <path
      d="M12.502 11.678a.862.862 0 01-.253.613 5.984 5.984 0 01-4.242 1.759l-.043-.002-.036-.002a5.973 5.973 0 01-4.164-1.754 5.983 5.983 0 01-1.757-4.215.21.21 0 01-.001-.028l.001-.043c0-.013.002-.025.003-.035a5.972 5.972 0 011.754-4.164A5.982 5.982 0 017.977 2.05a.21.21 0 01.028-.002.933.933 0 01.078.004 6.018 6.018 0 011.953.351c.543.195 1.064.47 1.544.828l.668-1.156a.205.205 0 01.37.027l1.318 3.452a.205.205 0 01-.153.29l-3.65.582a.204.204 0 01-.223-.302l.797-1.38a4.245 4.245 0 00-2.664-.964l-.02.001a.217.217 0 01-.044 0 4.255 4.255 0 00-2.99 1.25 4.267 4.267 0 00-1.252 2.98v.02a.204.204 0 010 .045 4.256 4.256 0 001.25 2.99 4.267 4.267 0 002.96 1.253l.02-.002h.02a.22.22 0 01.045 0 4.255 4.255 0 002.981-1.24l.002-.002.004-.003v-.002l.003-.002a.863.863 0 011.213-.013l.005.004.003.003h.001l.003.004a.863.863 0 01.255.613z"
      fill="currentColor"
    />
  </svg>
);
